export const query_prestazioni_byFascicolo = `
query getPrestazioniByFascicolo($fascicoloId: Int!) {
  prestazione(where: {FascicoloId: {_eq: $fascicoloId}}, order_by: {StartDate: desc}) {
    Id
    TipoKey
    PrestazioneId
    StartDate
    EndDate
    PaeseId
    ProvinciaId
    Provincia
    CittaId
    Citta
    ScopoId
    NaturaId
    Descrizione
    AstensioneMotivo
    IsEsoneroObbAst
    IsPrivate
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
    SettoreAttivita
    SettorePrestazione
    Ragione
    user {
      Name
      Surname
    }
    base_tipo_prestazione {
      BaseTenantTipoId
      Nome
      Regole
      Rischio
    }
    base_natura_prestazione {
      Value
    }
    base_scopo_prestazione {
      Value
    }
    prestazione_users {
      Id
      PrestazioneId
      UserId
    }
    prestazione_pagamentos {
      Id
      ValutaId
      ValutaData
      ValutaCambio
      ValutaImporto
      ImportoEuro
      ModalitaPagamentoId
      OrigineId
      CreatedOn
      ModifiedOn
      CreatedBy
      ModifiedBy
      Data
      IsoCode
      base_valutum {
        IsoCode
      }
      base_mezzo_pagamento {
        Value
      }
      base_origine_fondi {
        Value
      }
    }
    rischios(order_by: {Date: desc}) {
      Id
      Date
      DataControlloCostante
      ProvidedBy
    }
  }
}`;
export const query_prestazioni_byTenant_count = `
query countPrestazioniByTenant($tenantId: String!, $aziendaId: Int!) {
  prestazione_aggregate(where: {
    fascicolo: {
      TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
      _or: [
        {_or: [{IsPrivate: {_eq: false}}]}
      ]
    }
  }) {
    aggregate {
      count(columns: Id)
    }
  }
}`;
export const query_prestazioni_byTenant = `
query getPrestazioniByTenant($tenantId: String!, $aziendaId: Int!, $userId: String!) {
  prestazione(where: {
    fascicolo: {
      TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
      _or: [
        {_or: [{IsPrivate: {_eq: false}}]},
        {_or: [
          {prestaziones: {prestazione_users: {UserId: {_eq: $userId}}}}
        ]}
      ]
    }
  }, order_by: {StartDate: desc}) {
    Id
    TipoKey
    PrestazioneId
    StartDate
    EndDate
    PaeseId
    ProvinciaId
    Provincia
    CittaId
    Citta
    ScopoId
    NaturaId
    Descrizione
    AstensioneMotivo
    IsEsoneroObbAst
    IsPrivate
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
    fascicolo {
      Id
      Name
      Date
    }
    base_tipo_prestazione {
      Nome
      Rischio
    }
    base_scopo_prestazione {
      Value
    }
    base_natura_prestazione {
      Value
    }
    prestazione_pagamentos_aggregate {
      aggregate {
        count
      }
    }
    prestazione_users_aggregate {
      aggregate {
        count
      }
    }
    rischios_aggregate {
      aggregate {
        count
      }
    }
  }
}`;
export const query_prestazioni_byUserId_count = `
query countPrestazioniByUserId($userId: String!, $tenantId: String!) {
  prestazione_aggregate(where: {
    CreatedBy: {_eq: $userId},
    fascicolo: {
      TenantId: {_eq: $tenantId}
    }
  }) {
    aggregate {
      count(columns: Id)
    }
  }
}`;

// export const query_prestazioni_byUserId = `
// query getPrestazioniByUserId($userId: String!, $tenantId: String!) {
//   prestazione(where: {
//     CreatedBy: {_eq: $userId},
//     fascicolo: {
//       TenantId: {_eq: $tenantId}
//     }
//   }, order_by: {StartDate: desc}) {
//     Id
//     TipoKey
//     PrestazioneId
//     StartDate
//     EndDate
//     PaeseId
//     ProvinciaId
//     Provincia
//     CittaId
//     Citta
//     ScopoId
//     NaturaId
//     Descrizione
//     AstensioneMotivo
//     IsEsoneroObbAst
//     IsPrivate
//     CreatedOn
//     ModifiedOn
//     CreatedBy
//     ModifiedBy
//     fascicolo {
//       Id
//       Name
//       Date
//     }
//     base_tipo_prestazione {
//       Nome
//       Rischio
//     }
//     base_scopo_prestazione {
//       Value
//     }
//     base_natura_prestazione {
//       Value
//     }
//   }
// }`;